var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C31.0455 40 39.9998 31.0457 39.9998 20C39.9998 8.95429 31.0455 -1.52588e-05 19.9998 -1.52588e-05C8.95406 -1.52588e-05 -0.000244141 8.95429 -0.000244141 20C-0.000244141 31.0457 8.95406 40 19.9998 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 20C39.9999 12.0707 35.3855 5.2195 28.6956 1.9845V38.0154C35.3855 34.7804 39.9999 27.9292 39.9999 20V20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 27.9292 4.61445 34.7804 11.3044 38.0154V1.9845C4.61445 5.2195 0 12.0707 0 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4782 22.6086L26.9564 20.8695L25.2174 20V18.2608L21.7391 20L23.4782 16.5217H21.7391L19.9999 13.913L18.2608 16.5217H16.5217L18.2608 20L14.7825 18.2608V20L13.0435 20.8695L16.5217 22.6086L15.6521 24.3478H19.1304V26.9565H20.8695V24.3478H24.3478L23.4782 22.6086Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.f2554e8bade9c98786d4f4886fb8afb9.svg";
export { ForwardRef as ReactComponent };